const topics = [
  {
    title: "---Haliwa-Saponi---",
    subtitle1: "Topic: 1",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: [
     
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Lumbee Tribe---",
    subtitle1: "Topic: 2",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "---Meherrin---",
    subtitle1: "Topic: 3",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: [
     
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Occaneechi Band of the Saponi Nation---",
    subtitle1: "Topic: 4",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Sappony---",
    subtitle1: "Topic: 5",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "---The Eastern Band of Cherokee Indians---",
    subtitle1: "Topic: 6",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Waccamaw Siouan---",
    subtitle1: "Topic: 7",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Tribal Government---",
    subtitle1: "Topic: 8",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Tribal Sovereignty---",
    subtitle1: "Topic: 9",
    description: "3.B.1 Understand how values and beliefs of individuals and groups influence communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Bill of Rights---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Branches of Government---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Constitution---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 1)",
"The Constitution builds our government, step by step, you know it’s true!",
"It gives us leaders like the president, Congress, and the courts we use.",
"Each state has its own set of laws to guide its people every day,",
"But the U.S. Constitution is the highest, it leads the way!",
"In 1787, the framers made their plan, they made their plan.",
"George Washington, Ben Franklin, and others shaped this land.",
"They added amendments to protect our rights, so we’d be free.",
"And the government must follow them—it’s the law for you and me!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 2)",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"Added in 1791 to help our freedoms grow!",
"Added in 1791 to help our freedoms grow!",
"Thousands of changes were proposed, but only 27 were passed.",
"Thousands of changes were proposed, but only 27 were passed.",
"The Constitution stands the test of time, its strength will always last!",
"The Constitution stands the test of time, its strength will always last!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---How a Bill Becomes Law---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Levels of Government---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Local Government---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["(Chorus)",
"The mayor is the executive branch,",
"City court is judicial branch,",
"City council is the legislative branch,",
"Our local government, our local government.",

"(Verse 1)",
"The mayor's the boss, leading the team,",
"Making decisions that’s best for the team,",
"He's elected by the people, now he's got a say,",
"In what happens in our town every day.",
"The city council helps to decide,",
"What's best for the town we live in, you and I.",
"They make laws and rules, that we all follow,",
"To keep our town clean for better tomorrows.",
"The city courts enforce laws,",
"The city courts enforce laws,",
"The city court is the judicial branch,",
"Of our local government and they enforce laws.",

"(Chorus)",
"The mayor is the executive branch,",
"City court is judicial branch,",
"City council is the legislative branch,",
"Our local government, our local government.",

"(Verse 2)",
"Local government provides transportation,",
"They take care of parks and have a court system.",
"Local government builds and fixes roads,",
"Protects our town with fire and police departments.",
"Local government gives out marriage licenses,",
"Parking permits, and birth certificates.",
"Our taxes that we pay, pay for these services,",
"Our taxes that we pay, pay for these services.",

"(Chorus)",
"The mayor is the executive branch,",
"City court is judicial branch,",
"City council is the legislative branch,",
"Our local government, our local government.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---NC Government---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["(Chorus)",
"North Carolina’s Government, North Carolina’s Government,",
"Three parts of Government,",
"Executive, Judicial, Legislative,",
"North Carolina’s Government, North Carolina’s Government,",
"Three parts of Government,",
"Executive, Judicial, Legislative.",

"(Verse)",
"The Legislative Branch is made up of the",
"General Assembly,",
"They're divided into two parts,",
"The Senate and the House of Representatives.",
"The Legislative Branch in North Carolina",
"Makes the State laws,",
"The Legislative Branch in North Carolina",
"Makes the State laws.",

"The Executive Branch of North Carolina",
"Is headed by the Governor,",
"The Executive Branch makes sure",
"That they carry out State laws.",

"The Judicial Branch is made up of all courts,",
"The highest court is the Supreme Court.",
"They decide the cases",
"Of people accused of breaking laws,",
"And they check to see",
"If laws agree with North Carolina’s Constitution.",

"(Chorus)",
"Three parts of Government,",
"Executive, Judicial, Legislative,",
"North Carolina’s Government, North Carolina’s Government,",
"Three parts of Government,",
"Executive, Judicial, Legislative.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---State Government---",
    subtitle1: "Topic: 10",
    description: "3.C&G.1 Understand the structure and function of state and local government.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Entrepreneurs---",
    subtitle1: "Topic: 10",
    description: "3.E.1 Understand how economic decisions and resources affect the local economy.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Entrepreneurs on Communities---",
    subtitle1: "Topic: 10",
    description: "3.E.1 Understand how economic decisions and resources affect the local economy.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Franchises---",
    subtitle1: "Topic: 10",
    description: "3.E.1 Understand how economic decisions and resources affect the local economy.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Stockpiles---",
    subtitle1: "Topic: 10",
    description: "3.E.1 Understand how economic decisions and resources affect the local economy.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Supply & Demand---",
    subtitle1: "Topic: 10",
    description: "3.E.1 Understand how economic decisions and resources affect the local economy.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Continents & Oceans---",
    subtitle1: "Topic: 10",
    description: "3.G.1 Understand how geography impacts the development of regions and communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---NC 3 Regions---",
    subtitle1: "Topic: 10",
    description: "3.G.1 Understand how geography impacts the development of regions and communities.",
    video: "",
    music: "",
    lyrics: ["(Chorus)",
"North Carolina’s 3 Regions.",
"North Carolina’s 3 Regions.",
"Coastal Plain, Piedmont, and The Mountains.",

"(Verse)",
"Coastal Plain low flat land, Coastal Plain low flat land.",
"Eastern North Carolina, near the Atlantic Ocean.",
"Coastal Plain has two parts, Coastal Plain has two parts.",
"The outer Coastal Plain on the east side,",
"The inner Coastal Plain on the west side.",
"Piedmont rolling hills.",
"Piedmont low mountains.",
"Piedmont wide plateau that rise above all the land around it.",
"Blue Ridge Mountains are rounded part of the Appalachian Mountains.",
"Great Smoky Mountains are rounded part of the Appalachian Mountains.",
"Western North Carolina have mountains, that’s part of the Appalachian Mountains.",
"The Appalachian Mountains are mountains that stretch from Canada to Alabama.",

"(Chorus)",
"North Carolina’s 3 Regions.",
"North Carolina’s 3 Regions.",
"Coastal Plain, Piedmont, and The Mountains.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---NC Climate---",
    subtitle1: "Topic: 10",
    description: "3.G.1 Understand how geography impacts the development of regions and communities.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---NC Geography---",
    subtitle1: "Topic: 10",
    description: "3.G.1 Understand how geography impacts the development of regions and communities.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Physical Barriers ---",
    subtitle1: "Topic: 10",
    description: "3.G.1 Understand how geography impacts the development of regions and communities.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Weather vs Climate---",
    subtitle1: "Topic: 10",
    description: "3.G.1 Understand how geography impacts the development of regions and communities.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Battle of Bentonville---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Battle of Fort Fisher---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Battle of Kings Mountain---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Industrial Revolution---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---The Enfield Riots---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---The Mecklenburg Resolves---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["A push or a pull to an object.", "It’s what we call force!"],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Trail of Tears---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["(Chorus)",
"The Cherokee, Creek, Seminole, Trail of Tears.",
"The Chickasaw, Choctaw, Trail of Tears.",

"(Verse 1)",
"In the 1830s, long ago,",
"Native tribes were told to go.",
"Cherokee, Choctaw, Creek, and more,",
"Forced to leave their home's front door.",
"The Indian Removal Act was made,",
"Their happy homes began to fade.",
"President Jackson gave the call,",
"Move westward now, leave it all.",
"Through forests deep and rivers wide,",
"Many walked and many cried.",
"On a path of pain and fears,",
"This journey known as Trail of Tears.",

"(Chorus)",
"The Cherokee, Creek, Seminole, Trail of Tears.",
"The Chickasaw, Choctaw, Trail of Tears.",

"(Verse 2)",
"Through rain and cold, without enough,",
"The journey was so very tough.",
"Many lost their lives that day,",
"As they were forced to walk away.",
"We remember their brave fight,",
"Their courage shining bright.",
"The Trail of Tears, a tale of sorrow,",
"Honors their hope for a better tomorrow.",

"(Chorus)",
"The Cherokee, Creek, Seminole, Trail of Tears.",
"The Chickasaw, Choctaw, Trail of Tears.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---Wilmington Coup---",
    subtitle1: "Topic: 10",
    description: "3.H.1 Understand how various people and historical events have shaped local communities.",
    video: "",
    music: "",
    lyrics: ["(Chorus)",
"In North Carolina, Wilmington.",
"North Carolina, Wilmington Coup.",
" ",
"(Verse 1)",
"In 1898, in Wilmington town,",
"Black and white folks moved around.",
"Black leaders worked and held strong sway,",
"But some white folks wanted it their way.",
"On a sad November day,",
"White men came and made them pay.",
"With guns and fear, they took control,",
"Forcing Black leaders from their role.",
"",
"(Chorus)",
"In North Carolina, Wilmington.",
"North Carolina, Wilmington Coup.",
"",
"(Verse 2)",
"The Black newspaper was set aflame,",
"Many families fled in shame.",
"The act was called a coup, you see,",
"An unfair move in history.",
"Wilmington's tale is sad but true,",
"A lesson for both me and you.",
"Treat everyone with equal care,",
"To build a world that's just and fair.",
"",
"(Chorus)",
"In North Carolina, Wilmington.",
"North Carolina, Wilmington Coup.",
"",
"© Smart Board Learning, LLC. All rights reserved.",
],
    game: "",
    titleImage: "", // Empty string means no image for Force
  },

];
export default topics;